import MerckLanding from './MerckModule';

export default MerckLanding;
